import React from 'react';


export default function FieldTextViewInImport(props) {

    return (

        <div className="ui5-txt-default-small max-w-300">
            {props.value}
        </div>
    );
}